import { UniqNumberState } from "./types"

export const getUniqNumberFilters = (state: { uniqNumberGenerator: UniqNumberState }) => {
  return state.uniqNumberGenerator.filters
}

export const getUniqNumberLoading = (state: { uniqNumberGenerator: UniqNumberState }) =>
  state.uniqNumberGenerator.loading

export const getUniqNumber = (state: { uniqNumberGenerator: UniqNumberState }) =>
  state.uniqNumberGenerator.number
